import React from 'react';
import Span from '../../../../../common/text/Span';
import { ORANGE, DEEP_BLUE } from '../../../../../../styles/constants/color';
import { addComma } from '../../../../../../lib/common';
import { OtherBank } from '../../../../../../types/estimate/common/OtherBank';

interface Props {
  item: OtherBank;
  openCm: boolean;
  device: string;
  onClick: (param: OtherBank) => void;
}

/**
 *  타금융 할부목록 아이템 로우 컴포넌트
 * @param {OtherBank} item item
 * @param {boolean} openCm CM 펼치기 여부
 * @param {string} device pc or mobile
 * @param {function} onClick onClick
 *  */
function OtherBankItemRow({ item, openCm, device, onClick }: Props): JSX.Element {
  const { name, monthlyPayment, totalInterest, cmPer, cmPrice, interestRate, cashback } = item;
  return (
    <tr>
      <td onClick={() => onClick(item)}>
        <Span color={ORANGE}>적용</Span>
      </td>
      <td>
        <Span>{name}</Span>
      </td>
      <td>
        {device === 'pc' ? (
          <Span color={DEEP_BLUE}>{addComma(Math.round(monthlyPayment), true)}</Span>
        ) : (
          <>
            <Span>{addComma(Math.round(totalInterest), true)}</Span>
            <Span color={DEEP_BLUE}>{addComma(Math.round(monthlyPayment), true)}</Span>
          </>
        )}
      </td>
      <td>
        {device === 'pc' ? (
          <Span>{addComma(Math.round(totalInterest), true)}</Span>
        ) : (
          <>
            <Span>{interestRate}%</Span>
            <Span>{cashback}%</Span>
          </>
        )}
      </td>
      {device === 'pc' && (
        <>
          <td>
            <Span>{interestRate}%</Span>
          </td>
          <td>
            <Span>{cashback}%</Span>
          </td>
        </>
      )}
      {openCm && (
        <td>
          <Span>{cmPer}%</Span>
          <Span>({addComma(Math.round(cmPrice), true)})</Span>
        </td>
      )}
    </tr>
  );
}

export default OtherBankItemRow;
